module.exports = __webpack_public_path__ + "static/img/logo.d3e7557.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/login/logo.png
// module id = OelD
// module chunks = 1